import {h, Component} from 'preact';
import Search from '@components/search';
import take from 'ramda/src/take';

class FilterList extends Component {

    static defaultProps = {
        queryProps: [],
        list: [],
        renderer: () => {},
        onResultSelect: () => {},
        searchPlaceholder: null,
        maxResultCount: 7,
        enableSearchAtCount: 11
    };

    render ( {list, queryProps, filter, alwaysShowResults, renderer, maxResultCount, enableSearchAtCount, searchPlaceholder, onResultSelect} ) {

        if ( !list || list.length <= 0 ) {
            return <div>No Items in this list</div>
        }

        const remainingListCount = list.length - maxResultCount;
        const queryGroup = {list, queryProps, renderer, filter};

        if ( list.length > enableSearchAtCount ) {
            return (
                <Search
                    alwaysShowResults={alwaysShowResults}
                    onResultSelect={onResultSelect}
                    queryGroup={[queryGroup]}>
                    {searchProps =>
                        <div data-testid="filterlist-pane" className="py-4">
                            <span className="text-xs mb-1 block">
                                Filter from {list.length} items in this list
                            </span>
                            <div className="flex w-full lg:flex-1">
                                <Search.Input placeholder={searchPlaceholder}/>
                            </div>
                            <Search.Results activeClass="text-brand">
                                {results => <div className="my-2" data-testid="filterlist-results">{results}</div>}
                            </Search.Results>
                            {!searchProps.hasResults &&
                            <div className="my-2">
                                {take( maxResultCount, list ).map( renderer )}
                                {remainingListCount > 0 &&
                                <span className="text-sm">plus {remainingListCount} more...</span>
                                }
                            </div>
                            }
                        </div>
                    }
                </Search>
            );
        }

        return <div data-testid="filterlist-pane" className="py-4">{list.map( renderer )}</div>;

    }
}

export default FilterList;